import { Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import messages from "../../../assets/locale/messages";
import Button from "../../../components/Button";
import DatePicker from "../../../components/DatePicker";
import Input from "../../../components/Input";
import CustomSelect from "../../../components/Select";
import { getBooksRequest } from "../../../store/Books/actions";
import { getCountriesRequest } from "../../../store/Countries/actions";
import { addPromoCodeRequest } from "../../../store/Promocodes/actions";
import "./promocodeStyle.scss";
import { ADD_EDIT_PROMOCODE } from "./validation";
import { getAllPackagesRequest } from "../../../store/Packages/actions";
import Title_Section from "../../../components/Title_Section/Title_Section";

const AddPromoCodes = () => {
  const lang = useSelector((state) => state.locale.lang);
  const booksList = useSelector((state) => state.books.list);
  console.log("booksList", booksList);

  const countries = useSelector((state) => state.countries.list);
  const [promocodeType, setPromocodeType] = useState("normal");
  const [individualType, setIndividualType] = useState("normal");
  const [countryId, setCountryId] = useState(0);
  const {
    promoCodes: { name, offer, addPromocodes, expDate, books },
    buttons: { submit }
  } = messages[lang];

  const formRef = useRef();
  const dispatch = useDispatch();
  const today = new Date() + 1;
  const selectedCounty = useSelector(
    (state) => state.registeredUsers.selectedCounty
  );
  const Packages = useSelector(
    (state) => state.packagesReducer.packages
  );
  const selectedJob = useSelector(
    (state) => state.registeredUsers.selectedJob
  );

  const getInitialValues = () => {
    return {
      name: "",
      first_name: "",
      last_name: "",
      percentage: "",
      expiration_date: "",
      individualEmail: "",
      package_ids: [],
      book_ids: []
    };
  };

  useEffect(() => {
    dispatch(getBooksRequest({ lookup: true }));
    dispatch(getCountriesRequest());
    dispatch(getAllPackagesRequest());
  }, []);

  const handleSubmit = async (values) => {
    let payload = {
      ...values,
      filters: {
        country_ids: selectedCounty
          ? selectedCounty?.split(",").map(Number)
          : null,
        job_ids: selectedJob
          ? selectedJob?.split(",").map(Number)
          : null
      },
      code_type: promocodeType,
      email:
        promocodeType === "individual"
          ? values.individualEmail
          : null,
      individual_type: individualType,
      country_id: countryId
    };

    await dispatch(addPromoCodeRequest(payload));
  };

  const formatOptions = (element, id, label, value) => {
    return {
      id: element[id],
      label: element[label],
      value: element[value || id]
    };
  };

  const isIndividualPromocode = promocodeType === "individual";
  const isCountryPromocode = promocodeType === "country";

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <Title_Section title={addPromocodes} />
      </div>
      <Formik
        initialValues={getInitialValues()}
        innerRef={formRef}
        onSubmit={handleSubmit}
        validationSchema={ADD_EDIT_PROMOCODE(lang)}
        enableReinitialize
      >
        {({ setFieldValue, touched, errors }) => {
          return (
            <Form className="form">
              <div className="promocodeForm">
                <div>
                  <CustomSelect
                    options={[
                      {
                        id: "individual",
                        value: "individual",
                        label: "individual"
                      },
                      {
                        id: "country",
                        value: "country",
                        label: "country"
                      },
                      {
                        id: "normal",
                        value: "normal",
                        label: "normal"
                      }
                    ]}
                    placeholder={"Promocode Type"}
                    name="promocodeType"
                    handleSelectChange={(typeId) => {
                      setPromocodeType(typeId);
                    }}
                    isSearchable={true}
                    isMulti={false}
                    isRequired={true}
                    isAddNoneOption={false}
                  />
                  {errors.promocodeType && (
                    <>
                      <p className="error">{errors.promocodeType} </p>
                      <br />
                    </>
                  )}
                </div>
                <div>
                  {isIndividualPromocode && (
                    <CustomSelect
                      options={[
                        {
                          id: "normal",
                          value: "normal",
                          label: "normal"
                        },
                        {
                          id: "editor",
                          value: "editor",
                          label: "editor"
                        },
                        {
                          id: "author",
                          value: "author",
                          label: "author"
                        }
                      ]}
                      placeholder={"Individual Type"}
                      name="individualType"
                      handleSelectChange={(typeId) => {
                        setIndividualType(typeId);
                      }}
                      isSearchable={true}
                      isMulti={false}
                      isRequired={true}
                      isAddNoneOption={false}
                    />
                  )}
                  {errors.individualType && (
                    <>
                      <p className="error">
                        {errors.individualType}{" "}
                      </p>
                      <br />
                    </>
                  )}
                </div>
                {isIndividualPromocode && (
                  <Input
                    name="individualEmail"
                    label={"individual email"}
                    isRequired={isIndividualPromocode}
                    isNumber={false}
                  />
                )}
                {isIndividualPromocode && (
                  <>
                    <Input
                      name="first_name"
                      label={"First Name"}
                      isRequired={true}
                    />
                    <Input
                      name="last_name"
                      label={"Last Name"}
                      isRequired={true}
                    />
                  </>
                )}
                {isCountryPromocode && (
                  <div>
                    <CustomSelect
                      options={countries.map((country) =>
                        formatOptions(country, "id", "name")
                      )}
                      placeholder={"country"}
                      name="country"
                      handleSelectChange={(selectedCountryId) => {
                        setCountryId(selectedCountryId);
                      }}
                      isSearchable={true}
                      isMulti={false}
                      isRequired={isCountryPromocode}
                      isAddNoneOption={false}
                    />
                    {errors.country && (
                      <>
                        <p className="error">{errors.country} </p>
                        <br />
                      </>
                    )}
                  </div>
                )}
                <Input name="name" label={name} isRequired={true} />
                <Input
                  name="percentage"
                  type="number"
                  label={offer}
                  isRequired={true}
                  isNumber={true}
                  max="100"
                />
                <div>
                  <DatePicker
                    placeholder={expDate}
                    setFieldValue={setFieldValue}
                    name="expiration_date"
                    minDate={new Date(today).setDate(
                      new Date(today).getDate() + 1
                    )}
                    disablePast
                  />
                  {touched.expiration_date &&
                    errors.expiration_date && (
                      <div className="error-msg mt-2">
                        {errors.expiration_date}
                      </div>
                    )}
                </div>
                <CustomSelect
                  options={booksList.map((book) =>
                    formatOptions(book, "id", "title")
                  )}
                  placeholder={books}
                  name="book_ids"
                  // handleSelectChange={handleSelectBooksChange}
                  isSearchable={true}
                  isMulti={true}
                  isRequired={false}
                  isAddNoneOption={false}
                />
                <CustomSelect
                  options={Packages.map((book) =>
                    formatOptions(book, "id", "name")
                  )}
                  placeholder={"Packages"}
                  name="package_ids"
                  // handleSelectChange={handleSelectPackageChange}
                  isSearchable={true}
                  isMulti={true}
                  isRequired={false}
                  isAddNoneOption={false}
                />
              </div>
              <div className="flex-container">
                <Button text={submit} type="submit" />
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default AddPromoCodes;
